import "./CheckBox.scss";
export type Type = "checkbox" | "radio";
export type labelPosition = "left" | "right";

export interface Props {
  type: Type;
  className?: string;
  required?: boolean;
  id?: string;
  labelText: string;
  name?: string;
  disabled?: boolean;
  readOnly?: boolean;
  labelPosition?: labelPosition;
  onChange?: any;
  value?: any;
  checked?: boolean;
}

const CheckBox = ({
  type = "checkbox",
  className,
  required = false,
  id,
  labelText,
  name,
  disabled = false,
  readOnly = false,
  labelPosition = "left",
  onChange,
  value,
  checked = false,
}: Props) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      const input = e.target as HTMLInputElement;
      input.click();
    }
  };
  return (
    <div
      className={`checkBox${className ? " " + className : ""}${
        labelPosition ? " " + labelPosition : ""
      }${disabled ? " disabled" : ""}`}
    >
      <input
        type={type}
        name={type === "radio" ? name : ""}
        id={id ?? labelText?.replace(/ /g, "").substring(0, 5)}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        onChange={onChange}
        value={value}
        onKeyDown={handleKeyDown}
        checked={checked}
      />
      <label htmlFor={id ?? labelText?.replace(/ /g, "").substring(0, 5)}>
        {labelText}
        {required && <span>*</span>}
      </label>
    </div>
  );
};

export default CheckBox;
